import { axiosInstance, axiosInstanceForm } from "../../Utils/AxiosInstance";

const BASE = "/Procurement/Quote";

const call = async (fn) => {
  try {
    const response = await fn();
    return { ...response };
  } catch (error) {
    return { ...error?.response };
  }
};

const withProject = (projectId) => (projectId ? `?projectId=${projectId}` : "");

export const GetQuotablePrsApi = (projectId) =>
  call(() => axiosInstance.get(`${BASE}/GetQuotablePrs${withProject(projectId)}`));

export const GetAllQuotesApi = (projectId) =>
  call(() => axiosInstance.get(`${BASE}/GetAll${withProject(projectId)}`));

export const GetQuoteByIdApi = (id) => call(() => axiosInstance.get(`${BASE}/GetById/${id}`));

// data: FormData (PurchaseRequisitionId, VendorId, ..., Lines[i].*, File)
export const CreateQuoteApi = (data) => call(() => axiosInstanceForm.post(`${BASE}/Create`, data));

export const EditQuoteApi = (id, data) =>
  call(() => axiosInstanceForm.put(`${BASE}/Edit/${id}`, data));

export const DeleteQuoteApi = (id) => call(() => axiosInstance.delete(`${BASE}/Delete/${id}`));
